import React, { useContext, useEffect, useState } from "react";
import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  Tooltip,
  ResponsiveContainer,
  ReferenceDot,
  Customized,
} from "recharts";
import { AppContext } from "../../../context/Context";

const RevenueLineChart = ({ color, data }) => {
  const { dataRange, clearState } = useContext(AppContext);

  const [active, setActive] = useState();

  useEffect(() => {
    if (dataRange === "All") {
      if (clearState === "") {
        setActive(true);
        // console.log("testtrue");
      } else if (clearState === null) {
        // console.log("run else if");

        setTimeout(() => {
          setActive(true);
        }, 950);
      } else {
        setActive(false);
        // console.log("testtrue");
      }
    } else {
      if (clearState !== "") {
        setTimeout(() => {
          setActive(true);
        }, 950);
      }
    }
  }, [setActive, dataRange, clearState]);

  // console.log(active);

  if (!data || data.length === 0) return <p>No data available</p>;

  // console.log("checkdatarerender", dataRange === "All" && clearState !== null);

  // Find max value and its corresponding data point
  const maxValue = Math.max(...data.map((d) => d.value));
  const maxPoint = data.find((d) => d.value === maxValue);

  const CustomMaxLabel = ({ cx, cy }) => {
    return (
      <foreignObject x={cx - 30} y={cy - 50} width={70} height={40}>
        <div
          style={{
            backgroundColor: "#b0b3b8",
            color: "white",
            fontSize: "10px",
            fontWeight: "bold",
            padding: "6px 8px",
            borderRadius: "8px",
            boxShadow: "0px 2px 5px rgba(0,0,0,0.2)",
            textAlign: "center",
            position: "relative",
          }}
        >
          ${(maxValue / 1000000).toFixed(2)}M
          <div
            style={{
              position: "absolute",
              bottom: "-5px",
              left: "45%",
              transform: "translateX(-50%)",
              width: "0",
              height: "0",
              borderLeft: "6px solid transparent",
              borderRight: "6px solid transparent",
              borderTop: "6px solid #b0b3b8",
            }}
          />
        </div>
      </foreignObject>
    );
  };

  return (
    <ResponsiveContainer width="100%" height="100%">
      <LineChart
        data={data}
        margin={{ top: 100, right: 42, left: 20, bottom: 20 }}
      >
        <XAxis dataKey="month" tick={{ dy: 20 }} />
        <YAxis tickFormatter={(value) => `$${value / 1000000}M`} />
        <Tooltip
          formatter={(value) =>
            new Intl.NumberFormat("en-US", {
              style: "currency",
              currency: "USD",
            }).format(value)
          }
        />

        {/* Highlight max value with ReferenceDot */}
        {maxPoint && (
          <React.Fragment>
            <ReferenceDot
              x={maxPoint.month}
              y={maxPoint.value}
              r={8}
              fill="red"
              stroke="white"
              strokeWidth={2}
              cursor="pointer"
            />
            <Customized component={CustomMaxLabel} />
          </React.Fragment>
        )}

        {/* Line */}
        <Line
          type="monotone"
          dataKey="value"
          cursor="pointer"
          stroke={color}
          strokeWidth={3}
          dot={(props) => {
            const { cx, cy, payload, index } = props;
            const isMax = payload.value === maxValue;
            return isMax ? (
              <React.Fragment key={`dot-${index}`}>
                <circle
                  cx={cx}
                  cy={cy}
                  r={8}
                  fill={color}
                  stroke="white"
                  strokeWidth={2}
                  cursor="pointer"
                />
                <CustomMaxLabel cx={cx} cy={cy} />
              </React.Fragment>
            ) : (
              <circle
                key={`dot-${index}`}
                cx={cx}
                cy={cy}
                r={6}
                fill={color}
                stroke="white"
                strokeWidth={2}
                cursor="pointer"
              />
            );
          }}
          isAnimationActive={active === true ? true : false}
          animateNewValues={active === true ? true : false}
        />
      </LineChart>
    </ResponsiveContainer>
  );
};

export default RevenueLineChart;
